// extracted by mini-css-extract-plugin
export default {"ActionButton":"CardActionButton_ActionButton__TKCxf","ActionButtonDanger":"CardActionButton_ActionButtonDanger__-KPfp","ActionLabel":"CardActionButton_ActionLabel__ITXfy"};